// extracted by mini-css-extract-plugin
module.exports = {"inline":"feedback-widget_inline__1cIgo","large":"feedback-widget_large__PmiLi"};